<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--subheader">
            <td>
              <span>{{ 'plugins.counter-pressure.group' | translate }} N°</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.counter-pressure.measure' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngFor="let item of counterPressureCylinders; let i = index">
            <td>
              <span>{{ item.Id }}.</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="item.Measure-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  step="any"
                  [(ngModel)]="item.Measure"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
